import { useState, useEffect } from "react";
import { useTable } from "@refinedev/core";
import { getAgreementProductsService } from "@modules/agreements/services/realAgreementProductService";
import { AgreementProduct } from "@modules/agreements/types/agreementProduct";

export const useAgreementProductsList = () => {
  const [rows, setRows] = useState<AgreementProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const tableProps = useTable({
    resource: "agreement-products",
    pagination: {
      mode: "server",
    },
    sorters: {
      mode: "server",
    },
    filters: {
      mode: "server",
    },
  });

  const refetch = async () => {
    setLoading(true);
    try {
      const data = await getAgreementProductsService();
      setRows(data);
    } catch (error) {
      console.error("Error fetching agreement products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refetch();
  }, []);

  const dataToExport = rows?.map((row) => ({
    ID: row.id,
    Nome: row.name,
    Descrição: row.description || "",
    "ID do Produto Global": row.globalProductId,
    "Nome do Produto Global": row.globalProduct?.name || "",
    Ativo: row.isActive ? "Sim" : "Não",
    "Data de Criação": row.createdAt ? new Date(row.createdAt).toLocaleDateString("pt-BR") : "",
    "Data de Atualização": row.updatedAt ? new Date(row.updatedAt).toLocaleDateString("pt-BR") : "",
  }));

  const translate = (key: string) => {
    const translations: Record<string, string> = {
      "agreement-products": "Produtos dos Agreements",
      "create": "Criar",
      "edit": "Editar",
      "delete": "Excluir",
      "name": "Nome",
      "description": "Descrição",
      "globalProductId": "ID do Produto Global",
      "globalProductName": "Nome do Produto Global",
      "isActive": "Ativo",
      "createdAt": "Data de Criação",
      "updatedAt": "Data de Atualização",
    };
    return translations[key] || key;
  };

  return {
    rows,
    loading,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  };
};
